function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

/**
 * Get the CSRF cookie name, accounting for local-proxy per-slug namespacing.
 *
 * The local-proxy sets CSRF_COOKIE_NAME=csrftoken_{slug} to isolate parallel
 * instances sharing the .ahoylocal.ai cookie domain. The slug is derived from
 * the current hostname ({slug}.ahoylocal.ai).
 */
function getCSRFCookieName() {
  const { hostname } = window.location;
  // Detect local-proxy: {slug}.ahoylocal.ai (exclude local.ahoylocal.ai)
  // Same pattern as allauth.js redirectToProvider.
  //
  // The internal-dashboard (and other server-rendered pages) are served from the
  // "api-{slug}.ahoylocal.ai" subdomain, and the admin app is served from
  // "admin-{slug}.ahoylocal.ai", while the cookie the proxy sets is shared on
  // .ahoylocal.ai and namespaced with the bare branch slug (csrftoken_{slug}).
  // slugify_branch reserves the "api-"/"admin-"/"vite-" prefixes, so a branch
  // slug never itself begins with one of them. Strip a leading "api-" or
  // "admin-" so the embed mounted on that subdomain resolves the same cookie
  // name the SPA does on {slug}.ahoylocal.ai.
  const host = hostname.replace(/^(api|admin)-/, '');
  const slugMatch =
    host.match(/^([a-z0-9][a-z0-9-]*[a-z0-9])\.ahoylocal\.ai$/) ||
    host.match(/^([a-z0-9])\.ahoylocal\.ai$/);
  if (slugMatch && host !== 'local.ahoylocal.ai') {
    return `csrftoken_${slugMatch[1]}`;
  }
  return 'csrftoken';
}

export function getCSRFToken() {
  return getCookie(getCSRFCookieName());
}
